import { useContext } from 'react';
import { EditorContext } from './EditorContext';

export function useEditor() {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within an EditorProvider');
  }
  return context;
}

/**
 * Safe version of useEditor that returns null instead of throwing
 * when used outside of EditorProvider. Useful for optional editor features.
 */
export function useEditorSafe() {
  return useContext(EditorContext);
}
